import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";

const { Authorization, Bearer } = AUTHORIZATION;
const { post, get, put, del } = request;

const initialRoute = "groups/branding";

export const addGroupBranding = async (formData: FormData) => {
	try {
		const endpoint = initialRoute;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, formData, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const editGroupBranding = async (formData: FormData) => {
	try {
		const endpoint = initialRoute;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, formData, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.put.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const deleteGroupBranding = async (groupNumber: number) => {
	try {
		const endpoint = `${initialRoute}/${groupNumber}`;
		const token = localStorage.getItem("@jwt");
		const response = await del(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.delete.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const groupBranding = {
	addGroupBranding,
	editGroupBranding,
	deleteGroupBranding
};
